import { PARSE_QUERY_PARAMS } from "./query-params-action-types";
import getUrlParams from "./query-params-services";

const parseQueryParams = () => ({
    type: PARSE_QUERY_PARAMS,
    params: getUrlParams(),
    querystring: window.location.search
});

export default {
    parseQueryParams
};
